export default {
  name: 'th-TH',
  global: {
    undo: 'เลิกทำ',
    redo: 'ทำซ้ำ',
    confirm: 'ยืนยัน',
    clear: 'ล้าง',
  },
  Popconfirm: {
    positiveText: 'ยืนยัน',
    negativeText: 'ยกเลิก',
  },
  Cascader: {
    placeholder: 'กรุณาเลือก',
    loading: 'กำลังโหลด',
    loadingRequiredMessage: (label: string): string => `กรุณาโหลดรายการย่อยทั้งหมดของ ${label} ก่อนเลือก`,
  },
  Time: {
    dateFormat: 'yyyy-MM-dd',
    dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  },
  DatePicker: {
    yearFormat: 'yyyy',
    monthFormat: 'MMM',
    dayFormat: 'eeeeee',
    yearTypeFormat: 'yyyy',
    monthTypeFormat: 'yyyy-MM',
    dateFormat: 'yyyy-MM-dd',
    dateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
    quarterFormat: 'yyyy-qqq',
    weekFormat: 'yyyy-w',
    clear: 'ล้าง',
    now: 'ตอนนี้',
    confirm: 'ปิด',
    selectTime: 'เลือกเวลา',
    selectDate: 'เลือกวันที่',
    datePlaceholder: 'เลือกวันที่',
    datetimePlaceholder: 'เลือกวันที่และเวลา',
    monthPlaceholder: 'เลือกเดือน',
    yearPlaceholder: 'เลือกปี',
    quarterPlaceholder: 'เลือกไตรมาส',
    weekPlaceholder: 'เลือกสัปดาห์',
    startDatePlaceholder: 'วันที่เริ่มต้น',
    endDatePlaceholder: 'วันที่สิ้นสุด',
    startDatetimePlaceholder: 'วันที่และเวลาเริ่มต้น',
    endDatetimePlaceholder: 'วันที่และเวลาสิ้นสุด',
    startMonthPlaceholder: 'เดือนเริ่มต้น',
    endMonthPlaceholder: 'เดือนสิ้นสุด',
    monthBeforeYear: true,
    firstDayOfWeek: 0 as 0 | 1 | 2 | 3 | 4 | 5 | 6,
    today: 'วันนี้',
  },
  DataTable: {
    checkTableAll: 'เลือกทั้งหมดในตาราง',
    uncheckTableAll: 'ยกเลิกการเลือกทั้งหมดในตาราง',
    confirm: 'ยืนยัน',
    clear: 'ล้าง',
  },
  LegacyTransfer: {
    sourceTitle: 'ต้นทาง',
    targetTitle: 'ปลายทาง',
  },
  Transfer: {
    selectAll: 'เลือกทั้งหมด',
    unselectAll: 'ยกเลิกการเลือกทั้งหมด',
    clearAll: 'ล้างทั้งหมด',
    total: (num: number): string => `ทั้งหมด ${num} รายการ`,
    selected: (num: number): string => `เลือกแล้ว ${num} รายการ`,
  },
  Empty: {
    description: 'ไม่มีข้อมูล',
  },
  Select: {
    placeholder: 'กรุณาเลือก',
  },
  TimePicker: {
    placeholder: 'เลือกเวลา',
    positiveText: 'ตกลง',
    negativeText: 'ยกเลิก',
    now: 'ตอนนี้',
    clear: 'ล้าง',
  },
  Pagination: {
    goto: 'ไปที่',
    selectionSuffix: 'หน้า',
  },
  DynamicTags: {
    add: 'เพิ่ม',
  },
  Log: {
    loading: 'กำลังโหลด',
  },
  Input: {
    placeholder: 'กรุณากรอก',
  },
  InputNumber: {
    placeholder: 'กรุณากรอก',
  },
  DynamicInput: {
    create: 'สร้าง',
  },
  ThemeEditor: {
    title: 'ตัวแก้ไขธีม',
    clearAllVars: 'ล้างตัวแปรทั้งหมด',
    clearSearch: 'ล้างการค้นหา',
    filterCompName: 'กรองชื่อคอมโพเนนต์',
    filterVarName: 'กรองชื่อตัวแปร',
    import: 'นำเข้า',
    export: 'ส่งออก',
    restore: 'คืนค่าเริ่มต้น',
  },
  Image: {
    tipPrevious: 'รูปก่อนหน้า (←)',
    tipNext: 'รูปถัดไป (→)',
    tipCounterclockwise: 'หมุนทวนเข็มนาฬิกา',
    tipClockwise: 'หมุนตามเข็มนาฬิกา',
    tipZoomOut: 'ซูมออก',
    tipZoomIn: 'ซูมเข้า',
    tipDownload: 'ดาวน์โหลด',
    tipClose: 'ปิด (Esc)',
    tipOriginalSize: 'ซูมเป็นขนาดดั้งเดิม',
  },
}
